var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 13C19.2614 13 21.5 10.7614 21.5 8C21.5 5.23858 19.2614 3 16.5 3C13.7386 3 11.5 5.23858 11.5 8C11.5 10.7614 13.7386 13 16.5 13ZM16.5 16C20.9183 16 24.5 12.4183 24.5 8C24.5 3.58172 20.9183 0 16.5 0C12.0817 0 8.5 3.58172 8.5 8C8.5 12.4183 12.0817 16 16.5 16Z",
    fill: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 28V26C27.5 20.4772 22.0228 16 16.5 16C10.9772 16 5.5 20.4772 5.5 26V28C5.5 28.5523 5.94772 29 6.5 29H26.5C27.0523 29 27.5 28.5523 27.5 28ZM16.5 13C9.3203 13 2.5 18.8203 2.5 26V28C2.5 30.2091 4.29086 32 6.5 32H26.5C28.7091 32 30.5 30.2091 30.5 28V26C30.5 18.8203 23.6797 13 16.5 13Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiShop);
export default __webpack_public_path__ + "static/media/multi-shop.e77532a6b7904c54332e644b149a6782.svg";
export { ForwardRef as ReactComponent };